import React from "react";
import Icon from "shared/components/Icon";
import { COLORS, colors } from "shared/config/constants";

export type StatusType = "pass" | "fail" | "warn" | "pending";

interface StatusIconProps {
  status: StatusType;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Returns the appropriate color based on status
 */
export const getStatusColor = (status) => {
  if (status === "pass") {
    return colors.success[400];
  }
  if (status === "fail") {
    return COLORS.lightRed2;
  }
  if (status === "warn") {
    return COLORS.orange;
  }
  if (status === "pending") {
    return colors.neutral[400]; // Gray border for pending status
  }
  return "inherit";
};
/**
 * Reusable component that renders an icon based on status
 */
const StatusIcon: React.FC<StatusIconProps> = ({
  status,
  className = "",
  style = {}
}) => {
  switch (status) {
    case "pass":
      return <Icon.CheckGreenSmall className={className} style={style} />;
    case "fail":
      return <Icon.CrossRedSmall className={className} style={style} />;
    case "warn":
      return (
        <Icon.OrangeExclamationSmall className={className} style={style} />
      );
    case "pending":
      return null;
    default:
      return null;
  }
};

export default StatusIcon;
